// Texty detailu článku (articleDetail.js).
export default {
  authorNote: 'Poradna a servis nářadí, Bílina',
  /** fallback, když článek nemá vyplněného autora — popis redakce, ne osoba */
  authorFallback: 'Redakce Jipos',
  share: 'Sdílet',
  shareOne: 'Sdílet článek',
  copied: 'Odkaz zkopírován',
  toc: 'Obsah článku',
  prev: 'Předchozí',
  next: 'Následující',
  morePre: 'Další z rubriky ',
  moreAll: 'Zobrazit vše',
  shareFb: 'Sdílet na Facebooku',
  shareMail: 'Poslat e-mailem',
  shareCopy: 'Kopírovat odkaz',
  sharePrint: 'Vytisknout',
};
